var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6087 4.31323C13.2153 4.85948 12.9808 5.48158 12.8586 6.04554C16.8731 6.47391 20 9.87179 20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 10.5256 6.2149 7.56844 9.30977 6.46358C7.9332 5.72061 7 4.28135 7 2.62767V2.54654C7 2.24469 7.24873 2 7.55555 2C9.42804 2 11.0301 3.13918 11.6846 4.75149C11.8569 4.30607 12.0881 3.85799 12.3913 3.43677C13.2804 2.20198 14.7556 1.25 17 1.25C17.4142 1.25 17.75 1.58579 17.75 2C17.75 2.41421 17.4142 2.75 17 2.75C15.2444 2.75 14.2196 3.46468 13.6087 4.31323Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.1a3d47c6ae65833a3d588ff40759a35b.svg";
export { ForwardRef as ReactComponent };